// extracted by mini-css-extract-plugin
module.exports = {"label":"TextField_label__2hYGQ","fullWidth":"TextField_fullWidth__e9POY"};